import { styled } from 'stitches.config';
import { timings, animation } from 'Theme/Settings/animation';

const hoverCondition = '&:hover:not([disabled])';

export const ButtonVariants = {
  variants: {
    color: {
      primary: {
        backgroundColor: '$buttonPrimary',
        color: '$textSecondary',
        [hoverCondition]: {
          backgroundColor: '$JE68GreenHover',
        },
      },
      primary2: {
        backgroundColor: '$buttonPrimary2',
        color: '$textPrimary',
        [hoverCondition]: {
          backgroundColor: '$buttonPrimary2',
        },
      },
      secondary: {
        backgroundColor: '$buttonSecondary',
        color: '$textSecondary',
        [hoverCondition]: {
          backgroundColor: '$primaryLight1',
        },
      },
      secondaryDark: {
        backgroundColor: '$buttonSecondaryDark',
        color: '$textPrimary',
        [hoverCondition]: {
          backgroundColor: '$primary4',
        },
      },
      tertiary: {
        backgroundColor: 'transparent',
        color: '$textPrimary',
        // using box shadow to create a border - this way hover doesn't affect layout
        boxShadow: '0 0 0 1px $colors$borderPrimary',
        [hoverCondition]: {
          boxShadow: '0 0 0 2px $colors$borderPrimary',
        },
      },
      quaternary: {
        backgroundColor: '$primary2',
        color: '$textPrimary',
        [hoverCondition]: {
          backgroundColor: '$primary1',
        },
      },
      outlined: {
        backgroundColor: 'transparent',
        border: '1px solid $secondary2',
        [hoverCondition]: {
          backgroundColor: '$primary2',
        },
      },
    },
    size: {
      s: {
        py: 3,
        px: 6,
        fs: 6,
        h: 10,
        lineHeight: '$lh133',
      },
      l: {
        py: 3.5,
        px: 6,
        fs: 8,
        h: 12,
        lineHeight: '$lh125',
      },
    },
    fullWidth: {
      true: {
        width: '100%',
      },
    },
    loading: {
      true: {
        opacity: 0.7,
        fs: 7,
      },
    },
  },
  defaultVariants: {
    color: 'primary',
    size: 'l',
  },
};

export const ButtonBase = {
  borderColor: 'transparent',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  wordSpacing: '$wordSpacings$fontPrimary',
  whiteSpace: 'nowrap',
  fontFamily: 'fontPrimary500',
  ls: '$ls1',
  bw: 0.25,
  transition: `all ${timings.oneFifth} ${animation.timingFn}`,
  textAlign: 'center',
  textTransform: 'uppercase',
  '&:active': {
    outlineWidth: 0,
  },
  '&:focus': {},
  '&:disabled': {
    cursor: 'not-allowed',
    opacity: 0.5,
  },
};

const BaseButtonStyled = styled('button', {
  ...ButtonBase,
  ...ButtonVariants,
});

export default BaseButtonStyled;
